export interface Paged<T>{
  current_page: number,
  data: T[],
  from: number,
  last_page: number,
  per_page: number,
  to: number,
  total: number
}

export enum TableType {
  Users = 'users',
  Projects = 'projects',
  Clients = 'clients'
}

export enum Type {
  Active = 'active',
  Pending = 'pending',
  Prospects = 'prospects',
  Invited = 'invited',
  Applied = 'applied',
  ScheduleOverview = 'overview',
  ScheduleTimeline = 'timeline'
}
